import type { TestStepProps } from 'src/suitability/engine/types';
import { BLOCK2_QUESTIONS, type LiftAnswers } from './answers';
import { ScoredBlock } from './scored-block';

/** Bloque 2 — situación financiera. Ocho preguntas, sin reglas. */
export const StepBlock2 = (props: TestStepProps<LiftAnswers>) => (
  <ScoredBlock {...props} stepKey="block2" questions={BLOCK2_QUESTIONS} />
);
